module.exports = __webpack_public_path__ + "img/ballantines-first-block-bg.95704201.jpg";